import { defineComponent as _defineComponent } from 'vue'
import { inject, onMounted, ref } from "vue";
import dayjs from "dayjs";
import { IBookDetailInfo, ISeatInfo } from "@/domain/entities/book";
import { IBookResultDetailInfo } from "@/repositories/book/parsers/bookResultInfoParser";
import { useBookStore } from "@/stores/bookStore";
import SeatsLayout from "./SeatsLayout.vue";
import {
  BookStatusCode,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
} from "@/types";


const __default__ = {
  name: "MultipleBookDateSeats",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineTurnUid: {
    type: String,
    required: true,
  },
  boardingDates: {
    type: Array<IBookDetailInfo | IBookResultDetailInfo>,
    required: true,
  },
  isMonthlyBook: {
    type: Boolean,
    default: false,
  },
  isBookConfirmation: {
    type: Boolean,
    default: false,
  },
  seatAssignYn: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const bookStore = useBookStore();

const monthlyBookDetailsMap = ref<
  Map<string, (IBookDetailInfo | IBookResultDetailInfo)[]>
>(new Map());

const getBookListPerMonth = () => {
  const bookDateList = props.boardingDates;
  const sortedBookDataList = bookDateList.sort((date1, date2) => {
    return dayjs(date1.boardingDate).isAfter(dayjs(date2.boardingDate))
      ? 1
      : -1;
  });

  sortedBookDataList.forEach((date) => {
    const yearMonth = dayjs(date.boardingDate).format("YYYY-MM");
    const bookListInParsing = monthlyBookDetailsMap.value.get(yearMonth);
    if (!bookListInParsing) {
      monthlyBookDetailsMap.value.set(yearMonth, [date]);
    } else {
      bookListInParsing.push(date);
      monthlyBookDetailsMap.value.set(yearMonth, bookListInParsing);
    }
  });
};

const selectedBoardingDate = ref<IBookDetailInfo | IBookResultDetailInfo>(
  props.boardingDates?.[0]
);
const selectBoardingDate = (
  boardingDate: IBookDetailInfo | IBookResultDetailInfo
) => {
  if (
    !props.isBookConfirmation &&
    boardingDate.statusCode === BookStatusCode.CANCEL
  )
    return;
  selectedBoardingDate.value = boardingDate;
  mySeatNo.value = boardingDate.seatNo ?? "";
  const date = dayjs(selectedBoardingDate.value.boardingDate).format(
    "YYYY-MM-DD"
  );
  getSeatLayout(date, selectedBoardingDate.value.allocUid);
};

// 좌석 배치도 가져오기
const seatsInfosList = ref<Array<ISeatInfo | undefined>[]>([]);
const seatsRowsNumList = ref<number[]>([]);
const seatsColumnsNumList = ref<number[]>([]);
const mySeatFloor = ref(1);
const mySeatNo = ref(props.boardingDates[0]?.seatNo ?? "");

/** 좌석 정보 조회 */
const getSeatLayout = async (date: string, allocUid?: string) => {
  if (!selectedBoardingDate.value?.seatNo) return;

  const seatLayoutResult = await bookStore.getSeatLayout(
    props.lineTurnUid,
    date,
    false,
    allocUid
  );

  if (!seatLayoutResult.isSuccess) {
    showErrorModal(
      "좌석 배치도 조회 오류",
      seatLayoutResult.errorMessage,
      seatLayoutResult.resultCode,
      seatLayoutResult.errorTime
    );
    return;
  }

  seatsInfosList.value = seatLayoutResult.data?.seatLayout ?? [];
  seatsRowsNumList.value = seatLayoutResult.data?.numberOfRows ?? [];
  seatsColumnsNumList.value = seatLayoutResult.data?.numberOfColumns ?? [];

  updateMySeatFloor(selectedBoardingDate.value.seatNo);
};

const updateMySeatFloor = (seatNo: string) => {
  seatsInfosList.value.forEach((seatsInfo, index) => {
    const exist = seatsInfo.some((seat) => seat?.seatNo === seatNo);
    if (exist) {
      mySeatFloor.value = index + 1;
    }
  });
};

onMounted(() => {
  getBookListPerMonth();
  if (!props.seatAssignYn || !props.boardingDates.length) return;

  const firstBoardingDate = props.boardingDates[0];
  selectBoardingDate(firstBoardingDate);
  const date = dayjs(firstBoardingDate?.boardingDate).format("YYYY-MM-DD");
  getSeatLayout(date, firstBoardingDate.allocUid);
});

const __returned__ = { props, showErrorModal, bookStore, monthlyBookDetailsMap, getBookListPerMonth, selectedBoardingDate, selectBoardingDate, seatsInfosList, seatsRowsNumList, seatsColumnsNumList, mySeatFloor, mySeatNo, getSeatLayout, updateMySeatFloor, get dayjs() { return dayjs }, SeatsLayout, get BookStatusCode() { return BookStatusCode } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})